import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MenuItem } from 'react-bootstrap';
import { faEdit, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';

export default function DropdownMenuItem({
  disabled,
  disabledMessage,
  children,
  icon,
  isDelete,
  isEdit,
  label,
  onClick,
  ...props
}) {
  let content;
  if (children) {
    content = children;
  } else {
    if (isDelete) {
      icon = icon || faTrashAlt;
      label = label || 'Delete';
    } else if (isEdit) {
      icon = icon || faEdit;
      label = label || 'Edit';
    }

    content = icon
      ? <React.Fragment><FontAwesomeIcon fixedWidth icon={icon} /> {label}</React.Fragment>
      : label;
  }

  const menuItem =
    <MenuItem
      disabled={disabled}
      onClick={disabled ? null : onClick}
      {...props}
    >
      {content}
    </MenuItem>;

  return disabled && disabledMessage
    ? <Tooltip content={disabledMessage}>{menuItem}</Tooltip>
    : menuItem;
}

DropdownMenuItem.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  icon: PropTypes.object,
  isDelete: PropTypes.bool,
  isEdit: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
